<template>
  <smd-one-col-layout content-styles="d-root-services-find-services__content dark-light-bg">
    <div class="d-root-services-find-service__cards m-b-15">
      <smd-rectangle-card has-text-string
                          v-for="card in $options.ServicesCardItem"
                          :item="card"
                          :key="card.labelId"
                          @selected="handleCardSelection(card.labelId)">
        <div class="m-b-10" slot="title">
          <span class="services-card-title text-center p-t-10"
                :class="$isDesktop ? 'Title2' : 'Title1'">
            {{ getTitle(card) }}
          </span>
        </div>
        <div class="m-b-15 services-card-description" slot="description">
          <div class="services-card-subtitle Body2 gray-400">
            {{ getSubTitle(card) }}
          </div>
          <span class="Paragraph1 gray-400">
            {{ getDescription(card) }}
          </span>
        </div>
      </smd-rectangle-card>
    </div>

  </smd-one-col-layout>
</template>

<script>
  import RootServicesFindServicesMixin from '../root-services-find-services-mixin';

  export default {
    name: "d-root-services-find-service",
    mixins: [RootServicesFindServicesMixin],
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
      },
    }
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .d-root-services-find-services__content {
    padding: space(xxl) !important;

    > div {
      @include set-max-width($max-width: 1583px);
    }

    .smd-rectangle-card {
      &:hover {
        box-shadow: $desktop-purple-hover;
      }
    }
  }

  .d-root-services-find-service__cards {
    @include make-grid-cols(repeat(3, minmax(0, 496px)));
    @include responsive('max-width: 1400px') {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @include responsive('max-width: 900px') {
      grid-template-columns: minmax(0, 1fr);
    }
    grid-gap: space(xl);

    .Label1 {
      font-size: 24px;
      font-family: $D-DIN-Bold;
    }

    .text-string {
      text-align: left;
    }

    .services-card-subtitle {
      text-transform: capitalize;
    }

    .smd-rectangle-card {
      background: color(white);
    }

    .smd-rectangle-card--disabled {
      .services-card-description,
      .services-card-title {
        opacity: 0.4;
      }
    }
  }
</style>